/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const LoanPromoTitle = () => {
  const { t: translate } = useTranslation();

  return (
    <>
      {/* mobile layout */}
      <p
        className="d-block d-md-none text-uppercase"
        style={{
          fontSize: '2.125rem',
          fontFamily: 'HM Alpha Mono',
          fontStyle: 'normal',
          wordSpacing: '-10px',
          lineHeight: '120%',
        }}>
        {`${translate('promo_loans_subtitle_1')}`} <br />
        {`${translate('promo_loans_subtitle_2')}`}
      </p>

      {/*  browser layout */}
      <p
        className="d-none d-md-block text-uppercase"
        style={{
          fontSize: '2.875rem',
          fontFamily: 'HM Alpha Mono',
          fontStyle: 'normal',
          wordSpacing: '-10px',
          lineHeight: '120%',
        }}>
        {`${translate('promo_loans_subtitle_1')}`} {`${translate('promo_loans_subtitle_2')}`}
      </p>
    </>
  );
};
